<template>
<Layout>
  <ErrorPlankk :isView="true" />
</Layout>
</template>

<script>
import Layout from 'layouts/public';
import ErrorPlankk from 'Modals/ErrorPlankk';

export default {
  components: {
    ErrorPlankk,
    Layout,
  },
  props: {},
  page: {
    title: '401',
    meta: [{ name: 'description', content: '401' }],
  },
};
</script>

<style lang="scss" module>
@import 'theme.scss';
</style>
